import { render, staticRenderFns } from "./PromoCodeTableMobile.vue?vue&type=template&id=771d8b17&scoped=true"
import script from "./PromoCodeTableMobile.vue?vue&type=script&lang=js"
export * from "./PromoCodeTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771d8b17",
  null
  
)

export default component.exports